import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { CellId, Cell } from '../types/cell.type';

export const register = action(
  '[Cell] register',
  props<{ cell: Cell } & SkipHistory>(),
);

export const unregister = action(
  '[Cell] unregister',
  props<{ cellId: CellId } & SkipHistory>(),
);
